import React from "react";
import _ from "lodash";
import PriceSectionView from "components/common/PriceSectionView";
import PriceSettingView from "components/common/PriceSettingView";

class PropsElement extends React.PureComponent {
  render() {
    const { resourceType, item } = this.props;

    if (!item.props) return "--";

    let element = "";
    if (resourceType === "placement") {
      switch (item.props.type) {
        case "UPR_SEGMENT_OPT_X":
        case "UPR_SEGMENT_OPT": {
          element = (
            <div>
              <div>Segment ID: {item.props.segmentId}</div>
              <div>Price Setting ID: {item.props.priceSettingId}</div>
              <div>Price Index: {item.props.priceIndex}</div>
            </div>
          );
          break;
        }

        default: {
          let newProps = _.cloneDeep(item.props);
          newProps = _.omit(newProps, ["type"]);
          element = (
            <div className="text-gray-800">
              {_.keys(newProps).map((key) => {
                const value = newProps[key];
                return (
                  <div key={key}>
                    {key}:{" "}
                    <span className="font-semibold">
                      {typeof value === "object"
                        ? JSON.stringify(value)
                        : value}
                    </span>
                  </div>
                );
              })}
            </div>
          );
        }
      }
    }

    if (resourceType === "upr") {
      switch (item.props.type) {
        case "KEY16": {
          element = (
            <div>
              <div>UPR ID: {item.props.uprId}</div>
              <PriceSectionView
                item={{
                  price: item.props.price,
                  priceType: item.props.priceType,
                }}
              ></PriceSectionView>
            </div>
          );
          break;
        }
        case "KEY16L1": {
          element = (
            <div>
              <PriceSectionView
                item={{
                  price: item.props.price,
                  priceType: item.props.priceType,
                }}
              ></PriceSectionView>
            </div>
          );
          break;
        }

        case "CUSTOM": {
          const priceSettings = _.get(item, [
            "props",
            "priceSection",
            "priceSettings",
          ]);
          element = (
            <div>
              <div>ID: {item.props.id}</div>
              <div className="font-semibold">
                Price Settings ({priceSettings.length}):
              </div>
              <div className="flex-row gap-2 bg-gray-200">
                {priceSettings &&
                  priceSettings.map((s, i) => {
                    return <PriceSettingView s={s} key={i}></PriceSettingView>;
                  })}
              </div>
            </div>
          );
          break;
        }

        case "UPR_SEGMENTATION": {
          const priceSettings = _.get(item, ["props", "priceSettings"]);
          element = (
            <div>
              <div>Segment ID: {item.props.segmentId}</div>
              <div>Price Setting ID: {item.props.priceSettingId}</div>
              <div>Price Index: {item.props.priceIndex}</div>
              <div>
                OPT Type:{" "}
                <span className="rounded bg-teal-100 px-1 font-semibold text-teal-900">
                  {item.props.optType}
                </span>
              </div>

              <div className="border-t">
                <div className="font-semibold">
                  Price Settings ({priceSettings.length}):
                </div>
                <div className="flex-row gap-2 bg-gray-200">
                  {priceSettings &&
                    priceSettings.map((s, i) => {
                      return (
                        <PriceSettingView s={s} key={i}></PriceSettingView>
                      );
                    })}
                </div>
              </div>
            </div>
          );
          break;
        }

        case "PREBID": {
          const priceSettings = _.get(item, ["props", "priceSettings"]);
          element = (
            <div>
              <div className="font-semibold">
                Price Settings ({priceSettings.length}):
              </div>
              <div className="flex-row gap-2 bg-gray-200">
                {priceSettings &&
                  priceSettings.map((s, i) => {
                    return <PriceSettingView s={s} key={i}></PriceSettingView>;
                  })}
              </div>
            </div>
          );
          break;
        }

        default: {
          //
        }
      }
    }

    if (resourceType === "first_look") {
      element = (
        <div>
          <div>
            First Look Category:{" "}
            <span className="font-semibold">{item.props.flOptType}</span>
          </div>
          <div>
            ID: <span className="font-semibold">{item.props.id}</span>
          </div>
          <div>
            Name: <span className="font-semibold">{item.props.name}</span>
          </div>
          {/* <div>{JSON.stringify(item.props)}</div> */}
        </div>
      );
    }

    return element;
  }
}

export default PropsElement;
